/** Triggers a browser download for `url` by clicking a transient `<a download>`. Ported from audio-web. */
export const downloadFileByUrl = (url: string, filename: string, openNewTab = false): void => {
    const link = document.createElement('a')
    link.href = url
    link.download = filename

    if (openNewTab) {
        link.target = '_blank'
    }

    link.click()
}
